class {
  onCreate(input) {
    this.input = input;
  }
}

<section class="explainer-video-container">
  <h2 class="section-title" style="font-family: 'Cera Pro', sans-serif;font-size: 40px;margin: 10px auto;">Targeted, Organic <br class="hide-desktop"/> Instagram Growth</h2>
  <div class="video-wrapper custom-fluid" id="videoWrapper">
    <div id="videoClickArea" style="position: relative; width: 100%; height: 100%; cursor: pointer;">
      <div class="video-overlay" id="videoOverlay">
        <button class=[input.start ? 'play-button-large': 'play-button'] aria-label="Play explainer video"></button>
      </div>
      <picture>
        <source srcset="/img/icons/mobile-thumbnail-new.svg" media="(max-width: 499px)" style='border-radius: 20px;'/>
        <source srcset="/img/icons/desk-thumbnail-new.svg" media="(min-width: 500px)" />
        <img src="/img/icons/desk-thumbnail-new.svg" alt="Explainer video thumbnail" class=[input.start ? 'video-thumbnail-start' : 'video-thumbnail'] />
      </picture>
    </div>
  </div>
  <div class="explainer-video-section">
    <div class="main-video-container">
      <h2 class="headline">
        <span class="headline-main">Patented, Personalized </span>
        <span class="headline-break">AI Growth Service</span>
      </h2>
    </div>
    
  </div>
</section>

<script>
  // Helper to render the thumbnail and play button
  function renderThumbnail() {
    let wrapper = document.getElementById('videoWrapper');
      wrapper.innerHTML = `
      <div class="video-overlay" id="videoOverlay">
        <button class="play-button" aria-label="Play explainer video">
        </button>
      </div>
      <picture>
        <source srcset="/img/icons/mobile-thumbnail-new.svg" media="(max-width: 499px)" />
        <source srcset="/img/icons/desk-thumbnail-new.svg" media="(min-width: 500px)" />
        <img src="/img/icons/desk-thumbnail-new.svg" alt="Explainer video thumbnail" class="video-thumbnail" />
      </picture>
    `;
    
    attachPlayHandler();
  }

  function setSectionPadding(isMobile) {
    const section = document.querySelector('.explainer-video-section');
    if (!section) return;
    // if (isMobile) {
    //   section.style.paddingBottom = '7px';
    // } else {
    //   section.style.paddingBottom = '40px';
    // }
  }

  function setSectionPaddingVideoPlay(isMobile, addPadding) {
  const section = document.querySelector('.video-wrapper');
  if (!section) return;

  if (addPadding) {
    section.style.marginBottom = isMobile ? '30px' : '30px';
  } else {
    section.style.marginBottom = '20px';
  }
}


  function isMobileScreen() {
    return window.matchMedia('(max-width: 499px)').matches;
  }

  // Attach play button handler
  function attachPlayHandler() {
   const clickArea = document.getElementById('videoClickArea');
if (clickArea) {
  clickArea.addEventListener('click', () => {
    setSectionPadding(isMobileScreen());

    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    }

    window.onYouTubeIframeAPIReady = function() {
      createPlayer();
    };

    if (window.YT && window.YT.Player) {
      createPlayer();
    }
  });
}
  }

  // Create YouTube player and handle end event
function createPlayer() {
  const wrapper = document.getElementById('videoWrapper');
  wrapper.innerHTML = `
    <video id="localVideoPlayer" class="local-video-player" controls autoplay>
      <source src="/videos/Plixi_Epxlainer_Landscape.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  `;

  const videoPlayer = document.getElementById('localVideoPlayer');

  // Add padding when video is ready to play
  videoPlayer.addEventListener('canplay', () => {
    const isMobile = window.innerWidth < 768;
    setSectionPaddingVideoPlay(isMobile, true);
  });

  // Remove padding and restore thumbnail when video ends
  videoPlayer.addEventListener('ended', () => {
    renderThumbnail();
    setSectionPaddingVideoPlay(false, false); // reset padding
  });

  // Optional: remove padding if video is closed/removed manually
  videoPlayer.addEventListener('emptied', () => {
    setSectionPaddingVideoPlay(false, false);
  });
}


  function shouldShowVideoSection() {
    if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
      return Weglot.getCurrentLang() === 'en';
    }
    // Default to show if Weglot is not loaded
    return true;
  }

  function showOrHideVideoSection() {
    var section = document.querySelector('.explainer-video-container');
    if (!section) return;
    if (shouldShowVideoSection()) {
      section.style.display = '';
    } else {
      section.style.display = 'none';
    }
  }

  // Initial setup
  document.addEventListener('DOMContentLoaded', function() {
    attachPlayHandler();
    showOrHideVideoSection();
    if (window.Weglot) {
      Weglot.on('languageChanged', showOrHideVideoSection);
    }
  });
</script>

<style>

  .section-title{
    padding-bottom:50px;
  }

  .explainer-video-container{
    margin:0 auto;
    width:82%;
  }
  .explainer-video-container .section-title {
    padding-bottom: 20px;
  }
  .explainer-video-section {
    font-family: 'Plixi', sans-serif;
    background: linear-gradient(76deg, #4B25EA 2.2%, #BD18E6 45.47%, #FB590E 98.86%);
    border-radius: 30px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1); 
  }

  .main-video-container {
    position: relative;
    background: url(public/img/icons/explainer-card-bg.svg);
    height: 370px;
    margin-top: -310px;
    background-position: center center;
    background-size: cover;
    border-radius: 30px;
  }

  .video-wrapper {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    max-width: 950px;
    margin: 0 auto; 
    width: 80%; 
    z-index: 11;
    margin-bottom: 20px;
  }
  #localVideoPlayer {
    border: 10px solid white;
    border-radius: 26.8px;
  }
  .video-thumbnail {
    display: block;
    object-fit: contain;
    margin: 0 auto;
    width:100%;
    height:auto;
  }

  .video-thumbnail-start{
    display: block;
    object-fit: cover;
    width:100%;
    height:100%;
    margin: 0;
  }

  .youtube-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
  .video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 40px;
    color: white;
    z-index: 3;
    pointer-events: none;
    text-align: center;
  }

  .headline {
    padding-top:0px;  
    font-size: 30px;
    font-weight: 600;
    color: #fff;  
    text-align: center;  
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
    pointer-events: auto;
    z-index: 4;
    margin-bottom: 30px;
    padding-bottom: 5px;
  }
  .headline {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .headline-main {
    display: inline;
  }
  .headline-break {
    display: inline;

  }

  .circle1{
    position: absolute;
    width: 180px;
    height: 200px;
    top: 200px;
    left: -36px;
    border-radius: 50%;
    border: 9px solid #FFFFFF40;
    z-index: 1;
    overflow: hidden;
  }

.circle-start{
    opacity: 0.5 !important;
  }

.play-button {
    background: transparent;
    outline:none;
    margin-bottom:62px;
    border: none;
    cursor: pointer;
    pointer-events: auto;
    z-index: 4;
    border-radius: 50%;
    width:60px;
    height:60px;
  }

.play-button-large{
    background: transparent;
    outline:none;
    margin-bottom:62px;
    border: none;
    cursor: pointer;
    pointer-events: auto;
    z-index: 4;
    border-radius: 50%;
    width:60px;
    height:60px;
}

  .extra{
    width:107px;
    height:30px;
    position:absolute;
    background-color:#fff;
    top: 375px;
    left: 0;
    z-index: 999;
    }
   @media (max-width: 1023px) and (min-width: 768px) {
      .main-video-container {
      height: 310px;
      margin-top: -250px;
      border-radius: 30px !important;
    }
   }
  @media (max-width: 1050px) {
     .explainer-video-container {
      width: 100%;
     }
    }

  @media (max-width: 767px) {
    .headline-break {
      display: block;
      margin-bottom: 20px;
    }

    .section-title {
      font-size: 24px;
    }

    .youtube-iframe {
      height: 100%;
    }

    /* .play-button{
      margin-bottom: -11px;
    } */

    .explainer-video-container{
      width:100%;
    }

    .video-wrapper{
      width: 100%; 
    }

    .circle1{
      border: 5px solid #FFFFFF40;
      top:59px;
      left: -102px;
    }

    .circle2{
      border: 5px solid #FFFFFF40;
      top: 39px;
      right: -101px;
    }

    .headline {
      font-size: 23px;
    }

    .play-button-large >svg {
      width: 90px;
      height: 90px;
    }
    /*************/
    .explainer-video-section {
      border-radius: 0px !important;
    }
    .main-video-container {
      height: 250px;
      margin-top: -180px;
      border-radius: 0px !important;
    }
    .explainer-video-container {
      width: calc(100% + 80px) !important;
      margin-left: 0px !important;
      margin-right: 0px !important
    }
    .headline {
      margin-bottom: 0px;
    }
    #localVideoPlayer {
       /* width: calc(100% - 40px) !important; */
       width: 90% !important;
       margin: 0 auto;
    }
    .explainer-video-container .section-title {
      padding-bottom: 10px;
    }
    .empty-cont {
        margin-top: 20px !important;
      }

    @media(max-width: 600px){
      .play-button-large >svg {
        width: 70px;
        height: 70px;
      }
    }

    @media (max-width: 499px) {
      .play-button >svg {
        width: 60px;
        height: 60px;
      }

      .play-button-large >svg {
        width: 60px;
        height: 60px;
      }

      .play-button-large{
        margin-bottom: 55px;
      }

      .play-button{
        margin-bottom: 50px;
      }
    }
  }
  @media (max-width: 375px){
    .explainer-video-container {
      width: calc(100% + 40px) !important;
    }
    .main-video-container {
      height: 220px;
      margin-top: -150px;
      border-radius: 0px !important;
    }
  }
</style>
<if(input.leftmargin)>
  <style>
    @media (max-width: 768px) {
        .explainer-video-container{
            margin-left: -40px !important;
        }
    }
  </style>
</if>